import { render, staticRenderFns } from "./SelectStrategies.vue?vue&type=template&id=19be4b24&scoped=true"
import script from "./SelectStrategies.vue?vue&type=script&lang=js"
export * from "./SelectStrategies.vue?vue&type=script&lang=js"
import style0 from "./SelectStrategies.vue?vue&type=style&index=0&id=19be4b24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19be4b24",
  null
  
)

export default component.exports